module.exports = __webpack_public_path__ + "static/media/29EUNOG1.5ace9a1d.jpg";